import { Form, Row, Col } from "react-bootstrap";
import InputMask from "react-input-mask";
import { ErrorMessage } from "formik";
//import CustomAutoCompleteRegimenFiscal from "../../../../../components/formik/CustomAutoCompleteRegimenFiscal";
//import CustomAutoCompleteCFDI from "../../../../../components/formik/CustomAutoCompleteCFDI";

import  CustomAutoComplete  from "../../../../../components/formik/CustomAutoComplete";
import { findCFDIByCoincidence } from "../../../../../services/CatalogService";
import { findFiscalRegimesByCoincidence } from "../../../../../services/CatalogService";
import { useFormikContext } from "formik";

const CustomerSocialReasonFields = (
//   {
//   values,
//   errors,
//   touched,
//   handleChange,
//   handleBlur,
//   setFieldValue,
// }
) => {

  const formik = useFormikContext();
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
    validateField,
  } = formik;
  
  const ladaOptions = [
    { value: "1", label: "+1 (EE.UU./Canadá)" },
    { value: "52", label: "+52 (México)" },
    { value: "54", label: "+54 (Argentina)" },
    { value: "57", label: "+57 (Colombia)" },
    { value: "34", label: "+34 (España)" },
    { value: "51", label: "+51 (Perú)" },
    { value: "56", label: "+56 (Chile)" },
  ];

  return (
    <>
      {/* RFC y Régimen Fiscal */}
      <Row className="mb-3">
        <Form.Group as={Col} md="6" controlId="rfc">
          <Form.Label
            style={{ color: touched.rfc && errors.rfc ? "red" : "inherit" }}
          >
            RFC *
          </Form.Label>
          <Form.Control
            type="text"
            name="rfc"
            value={values.rfc}
            onChange={handleChange}
            isInvalid={touched.rfc && !!errors.rfc}
          />
          <Form.Control.Feedback type="invalid">
            {errors.rfc}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} md="6" controlId="fiscalRegimeId">
          {/* <CustomAutoCompleteRegimenFiscal
            formik={{
              values,
              setFieldValue,
              touched,
              errors,
            }}
            field="fiscalRegimeId"
          /> */}
          <CustomAutoComplete
            formik={formik}
            field="fiscalRegimeId"
            label="Régimen Fiscal"
            searchFunction={findFiscalRegimesByCoincidence}
            descriptionField="description" 
          />
          <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
            {errors.fiscalRegimeId}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      {/* Uso CFDI y Código Postal */}
      <Row className="mb-3">
        <Form.Group as={Col} md="6" controlId="cfdiId">
          {/* <CustomAutoCompleteCFDI
            formik={{
              values,
              setFieldValue,
              touched,
              errors,
            }}
            field="cfdiId"
          /> */}
          <CustomAutoComplete
            formik={formik}
            field="cfdiId"
            label="CFDI"
            searchFunction={findCFDIByCoincidence}
          />
          <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
            {errors.cfdiId}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} md="6" controlId="postalCode">
          <Form.Label
            style={{
              color:
                touched.postalCode && errors.postalCode ? "red" : "inherit",
            }}
          >
            Código Postal *
          </Form.Label>
          <Form.Control
            type="text"
            name="postalCode"
            value={values.postalCode}
            onChange={handleChange}
            isInvalid={touched.postalCode && !!errors.postalCode}
          />
          <Form.Control.Feedback type="invalid">
            {errors.postalCode}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      {/* Nombre, Teléfono y Web */}
      <Row className="mb-3">
        <Form.Group as={Col} md="4" controlId="name">
          <Form.Label
            style={{ color: touched.name && errors.name ? "red" : "inherit" }}
          >
            Nombre - Razón social*
          </Form.Label>
          <Form.Control
            type="text"
            name="name"
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            isInvalid={touched.name && !!errors.name}
          />
          {touched.name && errors.name && (
            <div className="text-danger">{errors.name}</div>
          )}
        </Form.Group>
        <Form.Group as={Col} md="2" controlId="lada_phone">
          <Form.Label
            style={{
              color: touched.lada_phone && errors.lada_phone ? "red" : "inherit",
            }}
          >
            Lada *
          </Form.Label>
          <Form.Select
            name="lada_phone"
            value={values.lada_phone}
            onChange={handleChange}
            onBlur={handleBlur}
            isInvalid={touched.lada_phone && !!errors.lada_phone}
          >
            <option value="">Seleccionar</option>
            {ladaOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Form.Select>

          <div className="invalid-feedback" style={{ display: "block" }}>
            <ErrorMessage name="lada_phone" />
          </div>
        </Form.Group>
        <Form.Group as={Col} md="3" controlId="phone">
          <Form.Label
            style={{ color: touched.phone && errors.phone ? "red" : "inherit" }}
          >
            Teléfono *
          </Form.Label>
          <InputMask
            mask="(999) 999-9999"
            name="phone"
            className={`form-control ${
              touched.phone && errors.phone ? "is-invalid" : ""
            }`}
            placeholder="(999) 999-9999"
            value={values.phone}
            onChange={handleChange}
          />
          <div className="invalid-feedback" style={{ display: "block" }}>
            <ErrorMessage name="phone" />
          </div>
        </Form.Group>

        <Form.Group as={Col} md="3" controlId="email">
          <Form.Label
            style={{ color: touched.email && errors.email ? "red" : "inherit" }}
          >
            Email *
          </Form.Label>
          <Form.Control
            type="text"
            name="email"
            value={values.email}
            onChange={handleChange}
            isInvalid={touched.email && !!errors.email}
          />
          <div className="invalid-feedback" style={{ display: "block" }}>
            <ErrorMessage name="email" />
          </div>
        </Form.Group>
      </Row>

      {/* País, Estado, Ciudad */}
      <Row className="mb-3">
        <Form.Group as={Col} md="4" controlId="country">
          <Form.Label>País</Form.Label>
          <Form.Control
            type="text"
            name="country"
            value={values.country}
            disabled
          />
        </Form.Group>
        <Form.Group as={Col} md="4" controlId="state">
          <Form.Label>Estado</Form.Label>
          <Form.Control
            type="text"
            name="state"
            value={values.state}
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group as={Col} md="4" controlId="city">
          <Form.Label>Ciudad</Form.Label>
          <Form.Control
            type="text"
            name="city"
            value={values.city}
            onChange={handleChange}
          />
        </Form.Group>
      </Row>

      {/* Municipio, Colonia, Nacionalidad */}
      <Row className="mb-3">
        <Form.Group as={Col} md="4" controlId="municipality">
          <Form.Label>Municipio</Form.Label>
          <Form.Control
            type="text"
            name="municipality"
            value={values.municipality}
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group as={Col} md="4" controlId="colonia">
          <Form.Label>Colonia</Form.Label>
          <Form.Control
            type="text"
            name="colonia"
            value={values.colonia}
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group as={Col} md="4" controlId="nationality">
          <Form.Label>Nacionalidad</Form.Label>
          <Form.Control
            type="text"
            name="nationality"
            value={values.nationality}
            onChange={handleChange}
          />
        </Form.Group>
      </Row>

      {/* Calle, No. Ext, No. Int */}
      <Row className="mb-3">
        <Form.Group as={Col} md="4" controlId="street">
          <Form.Label>Calle</Form.Label>
          <Form.Control
            type="text"
            name="street"
            value={values.street}
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group as={Col} md="4" controlId="numExt">
          <Form.Label>No. Exterior</Form.Label>
          <Form.Control
            type="text"
            name="numExt"
            value={values.numExt}
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group as={Col} md="4" controlId="numInt">
          <Form.Label>No. Interior</Form.Label>
          <Form.Control
            type="text"
            name="numInt"
            value={values.numInt}
            onChange={handleChange}
          />
        </Form.Group>
      </Row>

      {/* Entre calles y referencia */}
      <Row className="mb-3">
        <Form.Group as={Col} md="6" controlId="betweenStreet">
          <Form.Label>Entre calle</Form.Label>
          <Form.Control
            type="text"
            name="betweenStreet"
            value={values.betweenStreet}
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group as={Col} md="6" controlId="andStreet">
          <Form.Label>Y calle</Form.Label>
          <Form.Control
            type="text"
            name="andStreet"
            value={values.andStreet}
            onChange={handleChange}
          />
        </Form.Group>
      </Row>
      <Row className="mb-3">
        <Form.Group as={Col} md="12" controlId="reference">
          <Form.Label>Referencia</Form.Label>
          <Form.Control
            type="text"
            name="reference"
            value={values.reference}
            onChange={handleChange}
          />
        </Form.Group>
      </Row>
    </>
  );
};

export default CustomerSocialReasonFields;
